module.exports = __webpack_public_path__ + "img/hero-daddy-token.f274ce9c.png";